module.exports = __webpack_public_path__ + "pc/img/rec_18.dee326aa.svg";